export enum SwapSetError {
  FTL_LTL_CONFLICT = 'ftl-ltl-conflict',
  MULTIPLE_FTL = 'multiple-ftl',
  TOO_MANY_DRIVERS = 'too-many-drivers',
  ACTIVE_ORDER_WITHOUT_CARGO_SPACE = 'active-order-without-cargo-space',
}
